'use strict'

import CloudDataConnector from '../api.js'
import Plot from './base.js'

export default class PlotMelting extends Plot {
  constructor () {
    super('melting')
  }

  async dataFunction (controller) {
    // Get data from API
    const response = await new CloudDataConnector().getSnow(controller.uiElements.station.val())
    const height = controller.uiParams.height

    // Compute plot data
    const data = response.sort((left, right) => left.date < right.date ? -1 : (left.date > right.date ? 1 : 0))
    const dataPointsDate = data.map(item => new Date(item.melting_date))
    const xaxisDate = data.map(item => new Date(item.date))
    const milliSecondsInDays = 1000 * 60 * 60 * 24
    const xaxis = data.map(item => item.date)
    // Compute melting day in julian day
    const dataPoints = dataPointsDate.map((item, index) => (item.getTime() - xaxisDate[ index ].getTime()) / milliSecondsInDays)
    // Build labels for understanding
    // const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    const monthNames = [ 'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre' ]
    const dataTexts = dataPointsDate.map(item => item.getDate() + ' ' + monthNames[ item.getMonth() ])

    // Return elements to give to Plotly
    return {
      data: [
        {
          x: xaxis,
          y: dataPoints,
          mode: 'lines+markers+text',
          text: dataTexts,
          textposition: 'top',
          marker: {
            color: '#00AFD3'
          }
        }
      ],
      layout: {
        xaxis: { title: 'Année', autotick: false },
        yaxis: { title: 'Date de fonte' },
        margin: { t: 0 },
        height
      }
    }
  }
}
